export default "__VITE_ASSET__C36SHMhg__"